import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

// Define custom props
interface StyledBoxProps {
  size?: string | number;
  error?: boolean;
  disabled?: boolean;
}

const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size' && prop !== 'error',
})<StyledBoxProps>(({ theme, size, error, disabled }) => ({
  position: 'relative',
  height: '100%',
  '&:hover': {
    '& .IBIcon path': {
      fill: disabled
        ? theme.palette.action.disabled
        : error
        ? theme.palette.error.main
        : theme.palette.common.white,
    },
  },
  '& .IBIcon': {
    position: 'absolute',
    zIndex: 1,
    top: '50%',
    transform: 'translateY(-50%)',
    left: theme.spacing(3),
    width: size || theme.typography.pxToRem(24),
    height: size || theme.typography.pxToRem(24),
    '& path': {
      transition: 'fill .3s',
      fill: disabled
        ? theme.palette.action.disabled
        : error
        ? theme.palette.error.main
        : theme.palette.common.white,
    },
  },
  '& .MuiInputBase-root.Mui-disabled': {
    backgroundColor: 'unset',
  },
  '& .WidgetInputLabel':{
    color:disabled &&`${theme.palette.action.disabled} !important`,
  },
}));

export default StyledBox;